// Datos del responsable del tratamiento y fechas de vigencia de las páginas
// legales (/privacidad y /terminos). Una sola fuente de verdad: si cambia el
// RUC, la razón social o el domicilio fiscal, se cambia AQUÍ y las dos páginas
// (y su JSON-LD) quedan consistentes.
//
// Estos valores deben coincidir EXACTAMENTE con lo que consta en el RUC del
// SRI: la LOPDP exige identificar al responsable del tratamiento con datos
// reales y verificables. Si el RUC registra más nombres o apellidos que los de
// `razonSocial`, corrígelo aquí antes de publicar.
export const legalInfo = {
  razonSocial: 'Carolina Parra',
  // Persona natural, no compañía: el RUC (10 dígitos de cédula + 001) lo
  // confirma. Por eso los textos dicen "persona natural" y no "compañía".
  tipoPersona: 'persona natural',
  nombreComercial: 'Brazolovers',
  ruc: '1757881816001',
  // Calificación artesanal de la Junta Nacional de Defensa del Artesano. Define
  // el régimen bajo el que se emiten los comprobantes de venta, así que se
  // declara en /terminos.
  calificacionArtesanal: '227759',
  // Domicilio de la Matriz. OJO: no es literalmente igual a locations[0].address
  // en mock.js ("Sergio Jativa 175-147, Quito 170135"), que es el NAP que se
  // publica en el JSON-LD y debe calzar con la ficha de Google Business. Si se
  // unifican, hay que cambiar ambos a la vez y actualizar Google.
  domicilioFiscal: 'Sergio Játiva 180 y Bosmediano, Quito, Pichincha, Ecuador',
  // Mismo buzón que businessInfo.email en mock.js (footer, /contacto, JSON-LD):
  // el sitio entero usa una sola dirección. Si cambia, hay que tocar los dos.
  email: 'brazolovers@gmail.com',
  // Canal para ejercer derechos ARCO y demás derechos de la LOPDP.
  emailDatos: 'brazolovers@gmail.com',
  ciudad: 'Quito',
  pais: 'Ecuador',
};

// Fechas de última actualización que se muestran al usuario. Súbelas cada vez
// que cambies el texto de la página correspondiente.
export const legalDates = {
  privacidad: '2026-09-09',
  terminos: '2026-09-09',
};

export const formatLegalDate = (iso) => {
  const [y, m, d] = String(iso).split('-').map(Number);
  const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
    'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
  return `${d} de ${meses[m - 1]} de ${y}`;
};
